import {Box, Button, ButtonProps, CircularProgress} from "@mui/material";
import {FC, ReactNode} from "react";

interface IProps extends ButtonProps {
    loading?: boolean
    spinnerSize?: number
    loadingIndicator?: ReactNode
    preventTranslation?: boolean
}

const TranslateSafeLoadingButton: FC<IProps> = ({
                                                    loading = false,
                                                    spinnerSize = 20,
                                                    loadingIndicator,
                                                    preventTranslation = false,
                                                    disabled,
                                                    className,
                                                    children,
                                                    sx,
                                                    ...props
                                                }) => (
    <Button
        {...props}
        disabled={disabled || loading}
        {...(preventTranslation
            ? {
                translate: "no" as const,
                className: className ? `${className} notranslate` : "notranslate"
            }
            : {className})}
        aria-busy={loading}
        sx={{
            position: "relative",
            minWidth: 120,
            ...sx
        }}
    >
        <Box component="span" sx={{opacity: loading ? 0 : 1}}>
            {children}
        </Box>
        <Box
            component="span"
            sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                visibility: loading ? "visible" : "hidden",
                pointerEvents: "none"
            }}
            aria-hidden={!loading}
        >
            {loadingIndicator ?? <CircularProgress size={spinnerSize} color="inherit"/>}
        </Box>
    </Button>
)

export default TranslateSafeLoadingButton
